import { injectable, inject } from 'inversify';
import { NavigationEvent } from '@/app/statistics/events/navigation-events';
import { createCommand } from '@/app/tracking/api';
import { StoreCommandExecutor } from '@/app/tracking/common';
import * as Api from '../api'

@injectable()
export class SessionTimeProjection {

  private sessionTimeSeconds: number = 0

  constructor(
    @inject(StoreCommandExecutor)
    private readonly commandExecutor: StoreCommandExecutor) {
  }

  public handle(event: NavigationEvent) {
    switch (event.name) {
     case 'section-closed': {
       const durationSeconds = event.payload.durationSeconds;
       this.sessionTimeSeconds += durationSeconds

       const command = createCommand<Api.UpdateSessionTimeCommand>('update-session-time', {
         sessionTimeSeconds: this.sessionTimeSeconds
       })
       this.commandExecutor.queue(command);

       return true;
     }
    }

    return false;
  }
}
